import PropTypes from "prop-types";
import * as React from "react";
import classNames from "classnames";
import { translate } from "react-i18next";
import { ClanName, Realm, Spinner } from "@wg/wows-react-uikit";

import settings from "settings";

import { playDropdownSound } from "web2ClientAPI/web2ClientAPI";

import styles from "./Autocomplete.scss";

const propTypes = {
  isGlobalSearch: PropTypes.bool,
  isFetching: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired,
    hex_color: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired
  })),
  message: PropTypes.string,
  searchHistory: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      tag: PropTypes.string.isRequired,
      hex_color: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    }))
  }),
  term: PropTypes.string,
  totalClans: PropTypes.number,

  onHistoryItemClick: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,

  t: PropTypes.func.isRequired
};

class Autocomplete extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onListItemClick = this.onListItemClick.bind(this);
    this.onShowAllLinkClick = this.onShowAllLinkClick.bind(this);
  }

  renderRealm(item) {
    return <span className={styles.realmWrap}>
                <Realm tooltipId={`search-autocomplete-realm-${item.id}`} realm={item.realm} realmMap={settings.realmsMap} />
            </span>;
  }

  renderList({
    items,
    term
  }) {
    return items.map(item => {
      return <div className={styles.item} key={item.id} onClick={() => {this.onListItemClick(item);}}>
                    {this.renderRealm(item)}
                    <div className={styles.clanNameWrap}>
                        <ClanName clanName={item.name} clanTag={item.tag} clanColor={item.hex_color} highlight={term} />
                    </div>

                </div>;
    });
  }

  isSearchHistory() {
    return this.props.searchHistory.items.length && !this.props.term.length;
  }

  onListItemClick(item) {
    if (!this.isSearchHistory()) {
      this.props.onItemClick(item);
    }
    this.props.onHistoryItemClick(item);
    playDropdownSound();
  }

  renderMessage(message) {
    return <div className={styles.message}>{message}</div>;
  }

  renderSearchHistory() {
    const t = this.props.t;
    const items = this.props.searchHistory.items;
    const term = null;

    return <div>
                <div className={styles.title} id="search-history-list">
                    {t('Последние посещённые')}
                </div>
                {this.renderList({ items, term })}
            </div>;
  }

  onShowAllLinkClick() {
    this.props.onSubmit();
    playDropdownSound();
  }

  renderShowAllLink() {
    if (this.props.totalClans <= settings.search.autocompleteMaxResult || this.props.term.length < settings.search.minChars || this.props.isFetching) {
      return null;
    }

    const t = this.props.t;
    const displayedTotal = this.props.totalClans > settings.search.searchResultMaxItems ? `${settings.search.searchResultMaxItems}+` : this.props.totalClans;

    return <div className={styles.item} id="show-all" onClick={this.onShowAllLinkClick}>
                {t('Показать все (%(total)s)', { total: displayedTotal })}
            </div>;
  }

  renderSpinner() {
    const t = this.props.t;
    return <div className={styles.spinner}>
                <Spinner label={t('Ищем кланы')} />
            </div>;
  }

  render() {
    let content = null,
        contentStyle = {};

    if (this.props.isFetching) {
      if (this.autocomplete) {
        contentStyle.height = this.autocomplete.clientHeight;
      }
      content = this.renderSpinner();
    } else if (this.isSearchHistory()) {
      content = this.renderSearchHistory();
    } else if (this.props.message) {
      content = this.renderMessage(this.props.message);
    } else if (this.props.items.length > 0) {
      content = this.renderList(this.props);
    } else if (this.props.items.length === 0 && this.autocomplete) {
      contentStyle.height = this.autocomplete.clientHeight;
    }

    const classNameAutocomplete = classNames(styles.autocomplete, {
      [styles.showHistory]: this.isSearchHistory()
    });

    return <div className={classNameAutocomplete}>
                <div className={styles.inner} style={contentStyle} ref={auto => this.autocomplete = auto}>
                    {content}
                    {this.renderShowAllLink()}
                </div>
            </div>;
  }
}

Autocomplete.propTypes = propTypes;

export default translate()(Autocomplete);